import { PayrollAuditPage } from "../components/payroll/PayrollAuditPage.js";

export const PayrollChangesAuditPage = ({
  embedded = false,
}: {
  embedded?: boolean;
}) => <PayrollAuditPage level="changes" embedded={embedded} />;
